import { TFunction } from 'react-i18next';
import { notify } from 'components/Notifier';
import { ValidateViolation } from 'types';

export const DUPLICATE_RECEPTION_VIOLATION = 'Reception already exists with the given date/stream/client';
export const TWO_MONTH_AFTER_CLOSURE = 'TWO_MONTH_AFTER_CLOSURE';

const violationNameToTranslatorPath: { [key: string]: string } = {
  TWO_MONTH_AFTER_CLOSURE: 'errors.dateTwoMonthsAfterClosure',
};

export const generateNotifyFromViolations = (violations: ValidateViolation[], translator: TFunction): void => {
  violations.forEach((violation: ValidateViolation) => {
    const message = violationNameToTranslatorPath[violation.message]
      ? translator(violationNameToTranslatorPath[violation.message])
      : translator('errorGeneric');

    notify({
      message,
      severity: 'error',
      width: 'small',
      hiddenCloseButton: true,
    });
  });
};

export const isSubmissionErrorType = (object: any): boolean => {
  return (
    'object' === typeof object &&
    undefined !== object.status &&
    undefined !== object.response &&
    undefined !== object.response.body
  );
};
